import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Overview from "@/pages/Overview";
import Dashboard from "@/pages/Dashboard";
import AvailabilitySummary from "@/pages/AvailabilitySummary";
import Waitlist from "@/pages/Waitlist";
import Maintenance from "@/pages/Maintenance";
import SmsInbox from "@/pages/SmsInbox";
import Overdue from "@/pages/Overdue";
import MaintenanceAsset from "@/pages/MaintenanceAsset";
import EnquiryPublic from "@/pages/EnquiryPublic";
import MeterLogs from "@/pages/MeterLogs";
import SigenStor from "@/pages/SigenStor";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import { BackToTop } from "@/components/BackToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/maintenance/asset/:token" element={<MaintenanceAsset />} />
            <Route path="/enquire" element={<EnquiryPublic />} />
            <Route path="/" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
            <Route path="/units" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/availability" element={<ProtectedRoute><AvailabilitySummary /></ProtectedRoute>} />
            <Route path="/waitlist" element={<ProtectedRoute><Waitlist /></ProtectedRoute>} />
            <Route path="/maintenance" element={<ProtectedRoute><Maintenance /></ProtectedRoute>} />
            <Route path="/inbox" element={<ProtectedRoute><SmsInbox /></ProtectedRoute>} />
            <Route path="/overdue" element={<ProtectedRoute><Overdue /></ProtectedRoute>} />
            <Route path="/meter-logs" element={<ProtectedRoute><MeterLogs /></ProtectedRoute>} />
            <Route path="/sigenstor" element={<ProtectedRoute><SigenStor /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
          </Routes>
        </BrowserRouter>
        <BackToTop />
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
